// import components
import { showSnackbar } from '../components/shared';

// import hooks
import { useCallback } from 'react';
import { useMutation, useQueryClient } from 'react-query';

// import types
import { AxiosError, AxiosResponse } from 'axios';
import { UseUpdateResourceParams } from './useUpdateResource.types';

// import utils
import axios from 'axios';
import i18n from 'i18next';
import { replaceUrlParams } from 'components/employee-portal/travel-arrangements/utils';

export const useUpdateResource = ({
  url,
  params,
  id,
  invalidateQueryKey,
  message
}: UseUpdateResourceParams) => {
  const update = useCallback(
    (data) => {
      const baseUrl = replaceUrlParams(url, params || {});
      const finalUrl = id ? `${baseUrl}/${id}` : baseUrl;
      return axios.put(finalUrl, data);
    },
    [url, params, id]
  );

  const queryClient = useQueryClient();

  return useMutation<AxiosResponse, AxiosError, any>(update, {
    onSuccess: async (response) => {
      if (invalidateQueryKey) {
        await queryClient.invalidateQueries({
          queryKey: invalidateQueryKey
        });
      }
      showSnackbar({
        severity: 'success',
        message: message?.success ?? i18n.t('changesSaved')
      });
      return response;
    }
  });
};
